import "./ModalFotoPerfil.css";
// import { Slider } from "@material-ui/core";
import { useContext, useEffect, useRef, useState } from "react";
import Cropper from "react-easy-crop";
import DescargarIcon from "../../../assets/images/generico/DescargarIcon";
import { PortalContext } from "../../../context/Provider";
import HeaderModal from "../../Genericos/headerModal/headerModal";
import getCroppedImg from "../../../../global/utils/cropImage";
import { wsPostEditaImagenPerfil } from "../../../context/Actions/paciente/paciente";
import { hideModal } from "../../../context/Actions/modal/modal";
import AlertIcon from "../../../assets/images/generico/AlertIcon";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import { GlobalContext } from "../../../../global/context/Provider";
import { Device } from "@capacitor/device";

const ModalFotoPerfil = ({ titulo, dissmiss }) => {
  const {
    pacienteState,
    modalDispatch,
    pacienteDispatch,
  } = useContext(PortalContext);

  const {
    authState,
    toasterDispatch,
  } = useContext(GlobalContext);

  const [flgImagen, setFlgImagen] = useState(null);
  const [dtoImagenPerfil, setDtoImagenPerfil] = useState(null);

  const [imagen, setImagen] = useState(null);
  const [croppedArea, setCroppedArea] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  
  const [apk, setApk] = useState(null);

  const onCropComplete = (croppedAreaPercentage, croppedAreaPixels) => {
    setCroppedArea(croppedAreaPixels);
  };

  const onChangeVisualizarImagen = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0].size > 2e6) {
        showToaster(
          {
            texto: "La imagen no puede superar los 2MB",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.addEventListener("load", () => {
          setImagen(
            reader.result,
            e.target.files[0].type.replace("image/", "")
          );
        });
      }
    }
  };

  const subirImagen = async () => {
    const canvas = await getCroppedImg(imagen, croppedArea);
    const canvasDataUrl = canvas.toDataURL("image/jpeg", 0.8);
    var croppedImage = canvasDataUrl.split(",")[1];

    // Verificar tamaño de la imagen resultante (base64 ~= 4/3 del binario)
    const sizeInBytes = (croppedImage.length * 3) / 4;
    if (sizeInBytes > 1e6) {
      showToaster(
        {
          texto:
            "La imagen recortada es demasiado grande. Por favor elegí una imagen más pequeña o de menor resolución.",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
      return;
    }

    setDtoImagenPerfil({
      binario: croppedImage,
      idremoto: pacienteState.paciente.datosActualizados.id,
    });
    authState.auth.data.paciente.imagenPerfil = croppedImage;
    setFlgImagen(true);
  };

  useEffect(() => {
    Device.getInfo().then((info) => {
      if (info.platform === "web") {
        setApk(true);
      } else {
        setApk(false);
      }
    });
  }, []);

  useEffect(() => {
    if (flgImagen) {
      wsPostEditaImagenPerfil(dtoImagenPerfil)(pacienteDispatch);
      try {
        sessionStorage.setItem("auth", JSON.stringify(authState));
      } catch (e) {
        console.error("No se pudo guardar auth en sessionStorage", e);
      }
      setFlgImagen(null);
      hideModal()(modalDispatch);
    }
  }, [flgImagen]);

  const inputRef = useRef();
  const inputRefCamera = useRef();

  const seleccionarArchivo = () => inputRef.current.click();
  const tomarFoto = () => inputRefCamera.current.click();

  return (
    <>
      <HeaderModal titulo={titulo} dissmiss={dissmiss} />
      <div className="ptur-modalFotoPerfil-container">
        <div
          className={
            imagen
              ? "ptur-modalFotoPerfil-cajaFoto bgc-grey65"
              : "ptur-modalFotoPerfil-cajaFotoSubirImg bgc-grey65"
          }
        >
          {imagen ? (
            <Cropper
              image={imagen}
              crop={crop}
              zoom={zoom}
              aspect={1}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={onCropComplete}
            />
          ) : (
            <>
              <div className="ptur-modalFotoPerfil-subirImg-cont">
                <button
                  className="ptur-modalFotoPerfil-subirImg c-white bgc-grey65"
                  onClick={seleccionarArchivo}
                >
                  Subir Foto
                  <span>
                    <DescargarIcon color="#fff" width={50} height={40} />
                  </span>
                </button>
              </div>
            </>
          )}
        </div>
        <div className="ptur-modalFotoPerfil-cropper">
          <input
            type="file"
            name="image-upload2"
            id="input2"
            ref={inputRef}
            accept="image/*"
            onChange={onChangeVisualizarImagen}
            className="ptur-modalFotoPerfil-cajaFoto bgc-grey65"
            style={{ display: "none" }}
            autoComplete="off"
          />
          <input
            type="file"
            name="image-upload2"
            id="input2"
            ref={inputRefCamera}
            accept="image/*"
            capture="camera"
            multiple
            onChange={onChangeVisualizarImagen}
            className="ptur-modalFotoPerfil-cajaFoto bgc-grey65"
            style={{ display: "none" }}
            autoComplete="off"
          />
          {typeof window.orientation !== "undefined" ? (
            ""
          ) : (
            <>
              <div className="ptur-modalFotoPerfil-alertTextCont">
                <AlertIcon />
                <span className="ptur-modalFotoPerfil-alertText rb14m">
                  Utiliza la ruedita del mouse para hacer zoom en la imagen
                </span>
              </div>
            </>
          )}

          <div className="ptur-modalFotoPerfil-btn-container">
            <button
              className={
                imagen
                  ? "ptur-modalFotoPerfil-btnCambiar bgc-white c-latex30 rb16m"
                  : "ptur-modalFotoPerfil-btn bgc-latex30 c-white rb16m"
              }
              onClick={seleccionarArchivo}
            >
              {imagen ? "Elegir otra" : "Elegir Foto"}
            </button>
            {apk ? (
              ""
            ) : (
              <button
                className={
                  imagen
                    ? "ptur-modalFotoPerfil-btnCambiar bgc-white c-latex30 rb16m"
                    : "ptur-modalFotoPerfil-btn bgc-latex30 c-white rb16m"
                }
                onClick={tomarFoto}
              >
                {imagen ? "Tomar otra" : "Tomar Foto"}
              </button>
            )}

            {imagen ? (
              <button
                className="ptur-modalFotoPerfil-btn bgc-latex30 c-white rb16m"
                onClick={subirImagen}
              >
                Subir Foto
              </button>
            ) : (
              ""
            )}
          </div>

          {/* <Slider
            min={1}
            max={3}
            step={0.1}
            value={zoom}
            onChange={(e, zoom) => setZoom(zoom)}
          /> */}
        </div>
      </div>
    </>
  );
};

export default ModalFotoPerfil;
